import request from '@/utils/request'
import { arrayToFormDataToSave } from '@/utils/file.js'

// SDS 목록 조회
export function getSafetyDataSheetManageList(params, isProgress) {
  return request({
    url: `/api/getSafetyDataSheetManageList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}

// SDS 목록 저장
export function saveSafetyDataSheetManageList(params, isProgress) {
  return request({
    url: `/api/saveSafetyDataSheetManageList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}

// SDS 목록 삭제
export function deleteSafetyDataSheetManageList(params, isProgress) {
  return request({
    url: `/api/deleteSafetyDataSheetManageList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}

// 소중안 제공 데이터 불러오기
export function getSafetyDataSheetManageSampleData(params, isProgress) {
  return request({
    url: `/api/getSafetyDataSheetManageSampleData`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}

// 소중안 제공 데이터 저장 (관리자)
export function saveSafetyDataSheetManageSampleData(params, isProgress) {
  const formData = arrayToFormDataToSave(params)
  return request({
    url: `/api/saveSafetyDataSheetManageSampleData`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}